export default "__VITE_ASSET__BhFK_8U5__"